import React, { useEffect, useState } from "react";

import { Container, Subtitle, Title, Card, Select, NoData } from "./styles";
import { notification } from "antd";
import api from "../../../service";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import ChevronDown from "../components/Icons/chevron-down";
import { AttentionIcon } from "../Services/Sales/components/Icons";
import GoBackButton from "../components/goBackButton";

const StaffSelectEvent = () => {
  const [activeEvents, setActiveEvents] = useState([]);
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const history = useHistory();
  const locale = intl.locale;

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await api.get(`/admin/events`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        });

        const filteredEvents = response.data.output
          .filter((event) => event.active)
          .sort((a, b) =>
            a.eventEditionName.localeCompare(b.eventEditionName, locale, {
              sensitivity: "base",
            })
          );

        setActiveEvents(filteredEvents);
      } catch (error) {
        notification.error({
          message: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + error.response?.data?.description,
          }),
        });
      }
    };

    fetchEvents();
  }, []);

  const handleMenuClick = (e) => {
    const selectedEvent = activeEvents.find(
      (event) => event.eventEditionCode === e
    );

    if (!selectedEvent) return;

    const normalizeEventName = selectedEvent.eventEditionName.replace(
      / /g,
      "-"
    );

    const eventId = selectedEvent.idNumber;
    localStorage.setItem("serviceEventId", eventId);
    localStorage.setItem("serviceEventName", normalizeEventName);

    history.push("/staff-access/select-client");
  };

  return (
    <Container>
      <GoBackButton clearStorage href={"/"} intlId="backToPortal" noPosition />
      <Card>
        <Title> {intl.formatMessage({ id: "search_event" })}</Title>
        <Subtitle>
          {" "}
          {intl.formatMessage({ id: "event_edition_select" })}
        </Subtitle>
        <Select
          suffixIcon={<ChevronDown />}
          showSearch
          placeholder={intl.formatMessage({ id: "select" })}
          optionFilterProp="label"
          onChange={handleMenuClick}
          options={activeEvents.map((a) => ({
            label: a.eventEditionName,
            value: a.eventEditionCode,
          }))}
          notFoundContent={<NoDataComponent />}
        />
      </Card>
    </Container>
  );
};

export default StaffSelectEvent;

function NoDataComponent() {
  const intl = useIntl();
  return (
    <NoData>
      <AttentionIcon />
      <p>{intl.formatMessage({ id: "no_data_found" })}</p>
    </NoData>
  );
}
